import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { isPlatformServer } from '@angular/common';
import { OneTrustService } from '@www/_services';
import { setTheme } from 'ngx-bootstrap/utils';

@Component({
  selector: 'www-root',
  template: ` <router-outlet class="www-root" /> `,
  imports: [RouterModule],
  styles: [
    `
      ::ng-deep .www-root + * {
        display: block;
        animation: fade 0.25s;
        height: 100%;

        @keyframes fade {
          from {
            opacity: 0;
          }

          to {
            opacity: 1;
          }
        }
      }
    `,
  ],
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private readonly _ngbModal: NgbModal,
    private readonly _router: Router,
    @Inject(PLATFORM_ID)
    private readonly _platformId: string,
    private readonly _oneTrustService: OneTrustService,
  ) {
    setTheme('bs5');
  }

  public ngOnInit(): void {
    this._setRouterSubscription();
  }

  public ngAfterViewInit(): void {
    this._oneTrustService.addScriptToDom().then(() => {
      // this._googleTagManagerService.addScriptToDom().then(() => {
      //   this._angulartics2GoogleAnalytics.startTracking();
      //   this._angulartics2GoogleTagManager.startTracking();
      // });
    });
  }

  private _setRouterSubscription(): void {
    if (isPlatformServer(this._platformId)) {
      return;
    }
    this._router.events.subscribe((routeEvent) => {
      if (routeEvent instanceof NavigationEnd) {
        this._ngbModal.dismissAll();
      }
    });
  }
}
